import React from 'react';
import { InnerHeroBannerStyles as S } from './InnerHeroBanner.styles';
import SectionIntro from '@stories/Components/Misc/SectionIntro/SectionIntro';
import { getSrcs } from '@helpers/image';
import VideoWithControls from '@stories/Components/Misc/VideoWithControls/VideoWithControls';
import HeaderStyles from '../Global/Header/Header.styles';
import { withMotion } from '@hoc/withMotion';
import { MotionWrapper, rootMargin } from '@helpers/motionWrapper';
import { useInView } from '@netc/hooks';
const InnerHeroBanner = (props) => {
    const [elementRef, inView] = useInView({ rootMargin });
    const layout = React.useMemo(() => {
        if (!props.mediaItems)
            return 'none';
        const anyImages = props.mediaItems.some((item) => item.type === 'image');
        const anyVideos = props.mediaItems.some((item) => item.type === 'video');
        if (!anyImages)
            return 'video-only';
        const imageCount = props.mediaItems.filter((item) => item.type === 'image').length;
        if (!anyVideos) {
            switch (imageCount) {
                default:
                case 1:
                    return 'image-only';
                case 2:
                    return 'two-images';
                case 3:
                    return 'three-images';
                case 4:
                    return 'four-images';
            }
        }
        if (imageCount === 2)
            return 'two-images-one-video';
        return 'one-image-one-video';
    }, [props.mediaItems]);
    const getImageSizes = () => {
        switch (layout) {
            case 'one-image-one-video':
            case 'two-images':
                return [876, 244, 8, 876 / 508];
            case 'three-images':
                return [576, 216, 8, 576 / 508];
            case 'four-images':
                return [426, 168, 6, 426 / 508];
            case 'two-images-one-video':
                return [351, 216, 8, 351 / 508];
            default:
            case 'image-only':
                // Assume largest possible image //
                return [1776, 343, 10, 1776 / 508, 343 / 428];
        }
    };
    return (React.createElement(MotionWrapper, { inView: inView },
        React.createElement(S.Container, { ref: elementRef, widgetTheme: props.widgetTheme, id: props.anchorId },
            React.createElement(S.Intro, null,
                React.createElement(SectionIntro, { ...props, useH1: true }),
                React.createElement(S.IntroRight, null,
                    props.introduction && (React.createElement("p", { "data-intro": true, dangerouslySetInnerHTML: { __html: props.introduction } })),
                    props.topLinks && props.topLinks?.length > 0 && (React.createElement(S.Links, null, props.topLinks.map((link, i) => (React.createElement(React.Fragment, null,
                        React.createElement("a", { key: `InnerHeroBanner_TopLink_${i}`, href: link.url, target: link.target }, link.text),
                        i < props.topLinks.length - 1 && React.createElement("div", { "data-spacer": true })))))),
                    props.searchPageUrl && props.searchTerm && (React.createElement(HeaderStyles.HeaderTextbox, { type: "search", defaultValue: props.searchTerm, placeholder: props.translations?.['custom.header.search-placeholder'], onKeyDown: (e) => {
                            if (e.key === 'Enter' && props.searchPageUrl) {
                                window.location.assign(props.searchPageUrl +
                                    (window.location.search &&
                                        !window.location.search.startsWith('?searchTerm=')
                                        ? '&'
                                        : '?') +
                                    'searchTerm=' +
                                    encodeURIComponent(e.target.value));
                            }
                        } })))),
            props.mediaItems && props.mediaItems?.length > 0 && (React.createElement(S.Media, { "data-layout": layout, "data-columns": props.mediaItems?.length || 1 }, props.mediaItems.map((item, i) => {
                const srcs = item.type === 'image'
                    ? getSrcs(item.image, ...getImageSizes())
                    : null;
                return (React.createElement(S.MediaItem, { key: `InnerHeroBanner_MediaItem_${i}` },
                    item.type === 'video' && item.video && (React.createElement(VideoWithControls, { video: item.video, eagerPoster: true })),
                    item.type === 'image' && (React.createElement("img", { ...srcs, loading: "eager", alt: item.image?.altText || `Related image for '${props.title}'`, fetchPriority: 'high', sizes: "90vw" }))));
            }))))));
};
export default withMotion(InnerHeroBanner);
